<div class="each-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header__content">
            <div class="page-left gap-2.5">
                <div class="page-icon">
                    <img
                        src="../assets/img/dashboard.svg"
                        class="h-8"
                        alt="Add tag"
                    />
                </div>

                <div class="page-headings">
                    <h1>{{ pageTitle }}</h1>

                    <p *ngIf="pageSubtitle">
                        {{ pageSubtitle }}
                    </p>
                </div>
            </div>
        </div>

        <div class="page-header-right"></div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
        <section class="course-table-card">
            <div class="create-page">
                <form
                    class="create-page__form"
                  
                    (ngSubmit)="submitTag()"
                    novalidate
                >
                    <!-- Name -->
                    <div class="create-page__group">
                        <label for="tagName">
                            Name

                            <span class="create-page__required">
                                *
                            </span>
                        </label>

                        <div
                            class="create-page__control"
                            [class.create-page__control--invalid]="
                                isSubmitted &&
                                nameControl.invalid
                            "
                        >
                            <span class="create-page__control-icon">
                                <svg
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M20 13 11 4H4v7l9 9Z"
                                    ></path>

                                    <circle
                                        cx="7.5"
                                        cy="7.5"
                                        r="1"
                                    ></circle>
                                </svg>
                            </span>

                            <input
                                id="tagName"
                                type="text"
                                formControlName="name"
                                placeholder="Enter tag name"
                                autocomplete="off"
                            />
                        </div>

                        <p
                            class="create-page__error"
                            *ngIf="
                                isSubmitted &&
                                nameControl.hasError(
                                    'required'
                                )
                            "
                        >
                            Tag name is required.
                        </p>

                        <p
                            class="create-page__error"
                            *ngIf="
                                isSubmitted &&
                                nameControl.hasError(
                                    'maxlength'
                                )
                            "
                        >
                            Tag name cannot exceed
                            100 characters.
                        </p>
                    </div>

                    <!-- Actions -->
                    <div class="create-page__actions">
                      

                        <button
                            type="button"
                            class="create-page__button create-page__button--secondary"
                            [disabled]="isSaving"
                            (click)="cancel()"
                        >
                            <i
                                class="fa fa-times-circle"
                                aria-hidden="true"
                            ></i>

                            <span>Cancel</span>
                        </button>

                        <button
                            type="submit"
                            class="create-page__button create-page__button--primary"
                            [disabled]="isSaving"
                        >
                            <span
                                class="create-page__spinner"
                                *ngIf="isSaving"
                                aria-hidden="true"
                            ></span>

                            <svg
                                *ngIf="!isSaving"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    d="M4 4h13l3 3v13H4Z"
                                ></path>

                                <path
                                    d="M8 4v6h8V4"
                                ></path>
                            </svg>

                            <span>
                                {{
                                    isSaving
                                        ? 'Saving...'
                                        : 'Save'
                                }}
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>